import { InjectionToken } from "@angular/core";

export const STICKY_NOTIFICATION_DATA = new InjectionToken<any>(
  "STICKY_NOTIFICATION_DATA"
);
